"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isValid_1 = __importDefault(require("date-fns/isValid"));
const parse_1 = __importDefault(require("date-fns/parse"));
const format_1 = __importDefault(require("date-fns/format"));
const mask_1 = __importDefault(require("../../../../../utils/mask"));
const dateFormatToMask = (format) => format.toLowerCase().replace(/[dmy]/g, '#');
const getInputDateFormatState = ({ input, format, viewFormat, keyboard = false, finished = false, typeahead = false, }) => {
    const { complete, maskedValue } = (0, mask_1.default)(input || '', dateFormatToMask(keyboard ? viewFormat : format), { typeahead });
    const parsedDate = (0, parse_1.default)(maskedValue, keyboard ? viewFormat : format, new Date());
    const isDateValid = (0, isValid_1.default)(parsedDate);
    const isDateCorrect = input === '' || // allow clear field
        (complete && isDateValid);
    const value = input && isDateCorrect ? (0, format_1.default)(parsedDate, format) : maskedValue;
    // eslint-disable-next-line no-nested-ternary
    const viewValue = finished
        ? isDateCorrect && isDateValid
            ? (0, format_1.default)(parsedDate, viewFormat)
            : ''
        : maskedValue;
    return {
        complete,
        correct: finished !== false ? isDateCorrect : false,
        value,
        viewValue,
    };
};
exports.default = getInputDateFormatState;
